import { DashboardCard } from "@dashboard/components/Card";
import { Text } from "@saleor/macaw-ui-next";
import React from "react";
import { useIntl } from "react-intl";

import { railMessages } from "../../messages";

/**
 * What the right rail holds on the screens that have no record to describe yet
 * (settings, create a group, assign a customer). A rail with nothing in it is
 * what made these screens read as half-built.
 */
export const WsmDealerHelpCard = () => {
  const intl = useIntl();

  return (
    <DashboardCard data-test-id="wsm-dealer-help-card">
      <DashboardCard.Header>
        <DashboardCard.Title>
          {intl.formatMessage(railMessages.settingsTitle)}
        </DashboardCard.Title>
      </DashboardCard.Header>
      <DashboardCard.Content>
        <Text size={3} color="default2">
          {intl.formatMessage(railMessages.settingsBody)}
        </Text>
      </DashboardCard.Content>
    </DashboardCard>
  );
};

export default WsmDealerHelpCard;
